import { Button, Container, Divider, Modal, Typography, ModalTitle } from '@cleartrip/ct-design-components'
import React, { FC } from 'react'

import Image from 'next/image'
import { STUDENT_BENEFITS_MODAL_DATA } from '@/constants/components/fareType'

interface StudentFareIntlModalProps {
  open: boolean
  onClose: () => void
  onConfirm: () => void
}

const StudentFareIntlModal: FC<StudentFareIntlModalProps> = ({ open, onClose, onConfirm }) => {
  if (!open) return null

  const { title, subtitle, benefits, footerTitle, footerSubtitle, btnText } = STUDENT_BENEFITS_MODAL_DATA
  return (
    <Modal allowBackdropClose={true} open={open} size='MEDIUM' onClose={onClose}>
      <Container className='flex flex-column'>
        <ModalTitle styleConfig={{ root: { className: 'px-5 pt-5', css: { boxShadow: 'none' } } }}>
          <Typography className='mb-1' color='primary' variant='HD3'>
            {title}
          </Typography>
          <Typography color='subheading' variant='B2'>
            {subtitle}
          </Typography>
        </ModalTitle>
        <Container className='flex flex-column px-5'>
          <Container className='flex flex-row pt-4 pb-7'>
            {benefits.map((benefit, index) => (
              <>
                <Container key={benefit.label} className='flex flex-column flex-middle' style={{ flex: 1 }}>
                  <Container className='flex flex-middle flex-center'>
                    <Image alt='' height={44} src={benefit.icon} width={44} />
                  </Container>
                  <Typography className='mt-3 ta-center' color='primary' variant='B2'>
                    {benefit.label}
                  </Typography>
                </Container>
                {index < benefits.length - 1 && (
                  <Container
                    className='mx-5'
                    style={{
                      width: '1px',
                      height: '88px',
                      borderRight: '1px dashed #E6E6E6',
                    }}
                  />
                )}
              </>
            ))}
          </Container>
          <Divider borderColor='#E6E6E6' borderStyle='solid' />
          <Container className='py-4'>
            <Typography color='primary' variant='B3CAPS'>
              {footerTitle}
            </Typography>
            <Typography className='mt-1' color='primary' variant='P2'>
              {footerSubtitle}
            </Typography>
          </Container>
        </Container>

        <Container className='p-4'>
          <Button isFullWidth color='primary' size='medium' onClick={onConfirm}>
            {btnText}
          </Button>
        </Container>
      </Container>
    </Modal>
  )
}

export default StudentFareIntlModal
